import React from 'react';

import { useBreakpoint } from '../../hooks/useBreakpoint';

const EmptyFavoriteIcon = ({ dataTestId }: { dataTestId: string }) => {
  const { isMobile } = useBreakpoint();

  return (
    <svg
      data-testid={dataTestId}
      width={isMobile ? '200' : '256'}
      height={isMobile ? '160' : '205'}
      viewBox="0 0 200 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="200" height="160" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.3996 107.2H123.2C123.612 107.2 124.013 107.156 124.4 107.071C124.786 107.156 125.188 107.2 125.6 107.2H167.2C170.292 107.2 172.8 104.693 172.8 101.6C172.8 98.5074 170.292 96.0002 167.2 96.0002H162.4C159.307 96.0002 156.8 93.493 156.8 90.4002C156.8 87.3074 159.307 84.8002 162.4 84.8002H177.6C180.692 84.8002 183.2 82.293 183.2 79.2002C183.2 76.1074 180.692 73.6002 177.6 73.6002H160C163.092 73.6002 165.6 71.093 165.6 68.0002C165.6 64.9074 163.092 62.4002 160 62.4002H108.8C111.892 62.4002 114.4 59.893 114.4 56.8002C114.4 53.7074 111.892 51.2002 108.8 51.2002H63.1996C60.1068 51.2002 57.5996 53.7074 57.5996 56.8002C57.5996 59.893 60.1068 62.4002 63.1996 62.4002H31.1996C28.1068 62.4002 25.5996 64.9074 25.5996 68.0002C25.5996 71.093 28.1068 73.6002 31.1996 73.6002H51.1996C54.2924 73.6002 56.7996 76.1074 56.7996 79.2002C56.7996 82.293 54.2924 84.8002 51.1996 84.8002H19.1996C16.1068 84.8002 13.5996 87.3074 13.5996 90.4002C13.5996 93.493 16.1068 96.0002 19.1996 96.0002H50.3996C47.3068 96.0002 44.7996 98.5074 44.7996 101.6C44.7996 104.693 47.3068 107.2 50.3996 107.2ZM180.8 107.2C183.892 107.2 186.4 104.693 186.4 101.6C186.4 98.5074 183.892 96.0002 180.8 96.0002C177.707 96.0002 175.2 98.5074 175.2 101.6C175.2 104.693 177.707 107.2 180.8 107.2Z"
        fill="#F3F7FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M121.87 104.18C133.377 93.8929 139.245 83.7878 139.245 73.9689C139.245 61.8773 131.31 52.8901 120.771 52.8467C115.948 52.8467 113.287 53.3355 110.116 54.8782C108.166 55.8271 106.435 57.1082 104.926 58.7361L103.354 60.4317C102.567 61.2803 101.226 61.286 100.432 60.4441L98.8454 58.7618C97.3692 57.1965 95.6638 55.944 93.7343 54.9954C90.4678 53.3896 87.6294 52.8467 83.0233 52.8467C72.3525 52.8467 64.5342 61.7072 64.5342 73.9689C64.5342 83.7878 70.4024 93.8929 81.9098 104.18C87.8507 109.491 95.3981 114.799 100.972 117.844C101.545 118.157 102.234 118.157 102.808 117.844C108.381 114.799 115.929 109.491 121.87 104.18Z"
        fill="white"
      />
      <path
        d="M137.769 63.5917C137.771 63.5917 137.772 63.59 137.771 63.5884C135.53 58.513 131.838 54.8603 126.542 52.9311C123.727 51.9079 120.814 51.8477 117.882 51.9716C114.586 52.1132 111.463 52.8957 108.567 54.5279C106.382 55.7565 104.587 57.4241 102.934 59.2864C101.815 60.5433 101.709 60.5043 100.597 59.2404C98.6924 57.0665 96.5043 55.2714 93.8702 54.0145C90.6235 52.4673 87.1998 51.9044 83.9496 51.9433C78.221 51.8194 73.5475 53.618 69.7769 57.5303C65.8221 61.6338 64.0554 66.7038 63.673 72.2943C63.3225 77.4317 64.4838 82.2787 66.6966 86.8991C67.7652 89.1339 69.0256 91.2339 70.4282 93.2348C70.6369 93.5326 71.0359 93.6249 71.3533 93.4474C71.7239 93.2402 71.8241 92.7564 71.5804 92.4087C70.1554 90.376 68.9576 88.3458 67.9712 86.2866C65.7124 81.567 64.767 77.0245 65.0821 72.3899C65.4751 66.633 67.3445 62.0905 70.793 58.511C74.1388 55.0377 78.26 53.3524 83.3937 53.3524C83.5672 53.3524 83.7407 53.3524 83.9142 53.3595H84.2541C87.5326 53.3595 90.5598 54.0074 93.2541 55.2927C95.559 56.3902 97.609 57.987 99.5244 60.1715C100.208 60.9504 100.799 61.6231 101.769 61.6231C102.739 61.6231 103.373 60.9115 103.982 60.2246C105.805 58.1782 107.48 56.7584 109.254 55.76C111.845 54.3013 114.685 53.5259 117.935 53.3843C118.661 53.3524 119.298 53.3383 119.875 53.3383C122.393 53.3383 124.297 53.6215 126.054 54.2624C130.833 56.0008 134.338 59.3324 136.473 64.1617C139.334 70.6409 139.313 77.2865 136.403 84.4774C134.795 88.4534 132.444 92.2276 129.215 96.0195C122.336 104.099 113.708 111.123 102.838 117.496C102.445 117.727 102.095 117.84 101.766 117.84C101.436 117.84 101.065 117.716 100.672 117.458C99.6412 116.781 98.6074 116.116 97.5736 115.45C95.0739 113.839 92.4894 112.171 90.0393 110.426C85.9379 107.507 82.0577 104.175 78.46 100.517C78.1664 100.219 77.68 100.231 77.4079 100.549C77.1703 100.827 77.1853 101.239 77.4415 101.5C81.0728 105.197 84.9952 108.571 89.2179 111.58C92.6912 114.052 96.3237 116.303 99.8926 118.644C101.089 119.426 102.279 119.469 103.554 118.722C113.591 112.837 122.718 105.834 130.292 96.9401C133.354 93.3393 135.932 89.4129 137.713 85.0084C140.594 77.8824 140.906 70.7104 137.767 63.5949C137.766 63.5934 137.767 63.5917 137.769 63.5917Z"
        fill="#5C92FF"
      />
      <path
        d="M72.3643 94.9043L76.0749 99.371"
        stroke="#5C92FF"
        strokeWidth="1.3435"
        strokeLinecap="round"
      />
      <path
        d="M97.3522 80.343C96.9093 104.389 97.4512 102.541 103.637 111.669C104.156 112.436 103.446 113.381 102.583 113.044C93.5457 109.512 82.8087 101.067 73.8401 90.9334C73.8054 90.8942 73.7733 90.8516 73.7453 90.8073C64.559 76.3336 64.3194 63.5216 78.1054 57.6111C93.0016 53.445 97.6594 63.664 97.3522 80.343Z"
        fill="#EBF1FF"
      />
      <path
        d="M140 30C141.657 30 143 28.6569 143 27C143 25.3431 141.657 24 140 24C138.343 24 137 25.3431 137 27C137 28.6569 138.343 30 140 30Z"
        stroke="#75A4FE"
        strokeWidth="2"
      />
      <path
        d="M42 115C43.1046 115 44 114.105 44 113C44 111.895 43.1046 111 42 111C40.8954 111 40 111.895 40 113C40 114.105 40.8954 115 42 115Z"
        stroke="#75A4FE"
        strokeWidth="2"
      />
      <path
        d="M171 46C172.657 46 174 44.6569 174 43C174 41.3431 172.657 40 171 40C169.343 40 168 41.3431 168 43C168 44.6569 169.343 46 171 46Z"
        fill="#72A1FE"
      />
      <path
        d="M44.5 105C46.9853 105 49 102.985 49 100.5C49 98.0147 46.9853 96 44.5 96C42.0147 96 40 98.0147 40 100.5C40 102.985 42.0147 105 44.5 105Z"
        fill="#72A1FE"
      />
      <path
        d="M147.758 37.7578L156.116 46.116M156.243 37.7578L147.885 46.116L156.243 37.7578Z"
        stroke="#FF923F"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M59 122L63.9251 127M64 122L59.0749 127L64 122Z"
        stroke="#FF923F"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default EmptyFavoriteIcon;
